
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/question-form-cph",
      function () {
        return require("private-next-pages/question-form-cph.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/question-form-cph"])
      });
    }
  